export type EnvironmentMode = 'fake' | 'dev' | 'prod'

export interface EnvironmentConfig {
  mode: EnvironmentMode
  apiBaseUrl: string
  apiTimeout: number
  enableDevtools: boolean
  enableLogging: boolean
  showDevBanner: boolean
  isLocal: boolean
  firebase: {
    apiKey: string
    authDomain: string
    projectId: string
    storageBucket: string
    messagingSenderId: string
    appId: string
  }
}

class Environment {
  private static instance: Environment
  private config: EnvironmentConfig

  private constructor() {
    const mode = (import.meta.env.VITE_MODE || 'fake') as EnvironmentMode
    
    // Détecter si on est en local (équivalent du kDebugMode de Flutter)
    const isLocal = import.meta.env.DEV && (
      window.location.hostname === 'localhost' || 
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname.includes('localhost')
    )
    
    this.config = {
      mode,
      apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080',
      apiTimeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '10000'),
      enableDevtools: import.meta.env.VITE_ENABLE_DEVTOOLS === 'true',
      enableLogging: import.meta.env.VITE_ENABLE_LOGGING === 'true',
      showDevBanner: import.meta.env.VITE_SHOW_DEV_BANNER === 'true',
      isLocal,
      firebase: {
        apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
        authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
        projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
        storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
        messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
        appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
      },
    }

    // Log de debug pour vérifier la configuration
    if (this.config.enableLogging) {
      console.log('🔧 Environment Configuration:', {
        mode: this.config.mode,
        apiBaseUrl: this.config.apiBaseUrl,
        firebaseProjectId: this.config.firebase.projectId,
        enableDevtools: this.config.enableDevtools,
        isLocal: this.config.isLocal,
      })
    }
  }

  public static getInstance(): Environment {
    if (!Environment.instance) {
      Environment.instance = new Environment()
    }
    return Environment.instance
  }

  public getConfig(): EnvironmentConfig {
    return this.config
  }

  public isFakeMode(): boolean {
    return this.config.mode === 'fake'
  }

  public isDevMode(): boolean {
    return this.config.mode === 'dev'
  }

  public isProdMode(): boolean {
    return this.config.mode === 'prod'
  }

  public getTestCredentials(): { email: string; password: string } | null {
    const { mode, isLocal } = this.config
    
    if (mode === 'fake') {
      return {
        email: 'admin@skeenfit.com',
        password: 'password'
      }
    }
    
    if (mode === 'dev' && isLocal) {
      return {
        email: 'lucie@alpaga.io',
        password: '123456!@#$%ˆqwe!@#'
      }
    }
    
    // En prod ou dev non-local : pas de pré-remplissage
    return null
  }
}

export const environment = Environment.getInstance()